import styled from '@emotion/styled';

export const HeaderActionsContainer = styled.div`
  display: flex;
  padding-inline-start: 20px;
  align-items: center;

  /* @emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */
  > :not(:last-child) {
    margin-inline-end: 20px;
  }
`;
